export const LANGUAGES = [
  { value: 1, label: "languages.english" },
  { value: 2, label: "languages.german" },
  { value: 3, label: "languages.spanish" },
  { value: 4, label: "languages.italian" },
  { value: 5, label: "languages.french" },
];
